// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
    overflow-x: hidden;
    overflow-y: auto;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    display: block;
    width: 100%;
    height: 100%;
    max-height: 100%;
    padding: 0;
    margin: inherit;
    overflow: hidden;
    outline: 0;
    border-radius: 2px;
    background-color: rgba(0, 0, 0, 0.4);
    will-change: top, opacity;
}

.modal-dialog {
    position: relative;
    width: auto;
    max-width: 64rem;
    margin: 3.1rem auto;
    pointer-events: none;
}

.modal-content {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
}

.modal-header {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: start;
    align-items: flex-start;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 1.8rem 1.8rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
}

.modal-body {
    position: relative;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.8rem;
}

.modal-footer {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: end;
    justify-content: flex-end;
    padding: 1.2rem;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: calc(0.5rem - 1px);
    border-bottom-left-radius: calc(0.5rem - 1px);
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/modal-window/ModalWindow.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,0BAA0B;IAC1B,sBAAsB;IACtB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,4BAA4B;IAC5B,oCAAoC;IACpC,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;IACtB,gCAAgC;IAChC,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,6BAA6B;IAC7B,8CAA8C;IAC9C,6CAA6C;AACjD","sourcesContent":[".modal {\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1050;\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n    max-height: 100%;\r\n    padding: 0;\r\n    margin: inherit;\r\n    overflow: hidden;\r\n    outline: 0;\r\n    border-radius: 2px;\r\n    background-color: rgba(0, 0, 0, 0.4);\r\n    will-change: top, opacity;\r\n}\r\n\r\n.modal-dialog {\r\n    position: relative;\r\n    width: auto;\r\n    max-width: 64rem;\r\n    margin: 3.1rem auto;\r\n    pointer-events: none;\r\n}\r\n\r\n.modal-content {\r\n    position: relative;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    pointer-events: auto;\r\n    background-color: #fff;\r\n    background-clip: padding-box;\r\n    border: 1px solid rgba(0, 0, 0, 0.2);\r\n    border-radius: 0.3rem;\r\n    outline: 0;\r\n}\r\n\r\n.modal-header {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n    -ms-flex-pack: justify;\r\n    justify-content: space-between;\r\n    padding: 1.8rem 1.8rem;\r\n    border-bottom: 1px solid #dee2e6;\r\n    border-top-left-radius: calc(0.3rem - 1px);\r\n    border-top-right-radius: calc(0.3rem - 1px);\r\n}\r\n\r\n.modal-body {\r\n    position: relative;\r\n    -ms-flex: 1 1 auto;\r\n    flex: 1 1 auto;\r\n    padding: 1.8rem;\r\n}\r\n\r\n.modal-footer {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -ms-flex-pack: end;\r\n    justify-content: flex-end;\r\n    padding: 1.2rem;\r\n    border-top: 1px solid #dee2e6;\r\n    border-bottom-right-radius: calc(0.5rem - 1px);\r\n    border-bottom-left-radius: calc(0.5rem - 1px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
